module.exports = __webpack_public_path__ + "img/telegram_grey.813ea352.png";